export default __webpack_public_path__ + "static/media/thank-you-txt-img.2141fdc2.png";